var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnread = function SvgUnread(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 15,
      height: 10,
      viewBox: "0 0 15 10",
      fill: "#041F47",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM14 2C14.5523 2 15 1.55228 15 1C15 0.447715 14.5523 0 14 0V2ZM2.99993 3.99996C2.44764 3.99996 1.99993 4.44767 1.99993 4.99996C1.99993 5.55224 2.44764 5.99996 2.99993 5.99996V3.99996ZM11.9999 5.99996C12.5522 5.99996 12.9999 5.55224 12.9999 4.99996C12.9999 4.44767 12.5522 3.99996 11.9999 3.99996V5.99996ZM4.99993 8.00008C4.44764 8.00008 3.99993 8.4478 3.99993 9.00008C3.99993 9.55237 4.44764 10.0001 4.99993 10.0001V8.00008ZM9.99993 10.0001C10.5522 10.0001 10.9999 9.55237 10.9999 9.00008C10.9999 8.4478 10.5522 8.00008 9.99993 8.00008V10.0001ZM1 2H14V0H1V2ZM2.99993 5.99996H11.9999V3.99996H2.99993V5.99996ZM4.99993 10.0001H9.99993V8.00008H4.99993V10.0001Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgUnread, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/unread.6f218f87.svg";
export { ForwardRef as ReactComponent };